"use client";

import { useEffect, useState } from "react";
import { Icon } from "../_family/Icon";

/** Copies the code it sits on, and says so for a moment, to everyone who can see it or hear it. */
export function Copy({ text }: { text: string }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 1400);
    return () => clearTimeout(t);
  }, [copied]);

  return (
    <button
      className={copied ? "copy did" : "copy"}
      type="button"
      aria-label={copied ? "Copied" : "Copy the code"}
      onClick={() => {
        void navigator.clipboard
          ?.writeText(text)
          .then(() => setCopied(true))
          .catch(() => setCopied(false));
      }}
    >
      <Icon name="copy" className="cp" />
      <span className="ok">
        <Icon name="check" />
      </span>
      <span className="sr" aria-live="polite">
        {copied ? "Copied" : ""}
      </span>
    </button>
  );
}
